import { parseBooleanString } from "../../../util/utility";
import { CXoneAgentEvent } from '../agent/cxone-agent-event';
import { AgentLegStatus } from '../../enum/agent-leg-status';

/**
 * Model class for Agent leg event
 */
export class AgentLegEvent extends CXoneAgentEvent {
  /**
   * @remarks -
   * The 'contact ID' for the agent leg script. This can be helpful in situations where a single app is managing multiple agent sessions. 
   * This ID will be valid from the time the agent leg is 'dialing', until it is disconnected
   */
  public agentLegId!: string;

  /**
   * @remarks - 
   * Indicates whether the state is the final state for the agent leg "contact".
   * This will only be "true" for the "Disconnected" status event.
   */
  public finalState!: boolean;

  /**
   * @remarks - The status of the agent leg. Will be 'Dialing', 'Active', or 'Disconnected'.
   */
  public status!: AgentLegStatus;

  /**
   * The parse method will take the data object and assign the values to the agentLeg class properties
   * @param data - Data object received
   * @example -
   * ```
   * parse(data);
   * ```
   */
  public parse(data: { [key: string]: string }): void {
    this.iisHost = data.IISHost;
    this.vcHost = data.VCHost;
    this.agentLegId = data.AgentLegId;
    this.finalState = parseBooleanString(data.FinalState);
    this.status = data.Status as AgentLegStatus;
  }
}
